export default function(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/date.js
// module id = ./node_modules/d3-interpolate/src/date.js
// module chunks = 54